<template>
    <div class="distribution" :class="{ full: isFull }">
        <Title chineseTitle="配电图" englishTitle="Distribution chart" />
        <div class="distributionContent" :class="{ full: isFull }">
            <div class="title row-center" @click="showDiagramList = !showDiagramList" v-show="!isFull">
                <img src="@/assets/img/change.png" alt="" />
                <span>{{currentName}}</span>
            </div>
            <div class="list" v-show="showDiagramList && !isFull">
                <img class="close" @click="showDiagramList = false" src="@/assets/img/close.png" alt="关闭" />
                <!-- 类型 -->
                <div class="type row-center">
                    <span class="active">配电图列表</span>
                </div>
                <!-- 列表 -->
                <div class="names">
                    <span style="cursor: pointer;" v-for="(item, index) in details"
                        :class="{ active: index == currentIndex }" :key="index"
                        @click="currentIndex = index, getCurrentInfo(currentIndex)">{{ item.name }}</span>
                </div>
            </div>
            <!-- 全屏按钮 -->
            <div class="btn row-center" v-if="!isFull" @click="isFull = true">
                <img src="@/assets/img/fullScreen.png" alt="全屏" />
                <span>全屏</span>
            </div>

            <!-- 内容 -->
            <Diagram class="diagram" :isFull="isFull" :src="currentUrl" @onCancelFull="isFull = false"
                @loopDetail="loopDetail">
                <div slot="loopDetail">
                    <LoopDetail :width="1920" :height="1080" v-if="showLoopDetail" :tab="currentLoopTab"
                        :loopUrl="currentLoopUrl" @closeLoopDetail="showLoopDetail = false"
                        :currentLoop="loops.filter(item => item.subLoopUrl == currentLoopUrl)" />
                </div>
            </Diagram>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title";
    import Diagram from "@/components/Diagram";
    import LoopDetail from "@/components/loopDetail"

    import {
        GetDistribution,
        GetAllLoopsByProjectId,
    } from "../../components/Request";

    export default {
        name: "Distribution",
        components: {
            Title,
            Diagram,
            LoopDetail,
        },
        props: ["areaId"],
        data() {
            return {
                currentName: '',
                currentUrl: '',
                currentId: '',
                showDiagramList: false,
                isFull: false,
                details: [],
                currentIndex: 0,

                loops: [],
                showLoopDetail: false,
                currentLoopTab: '',
                currentLoopUrl: '',
            };
        },
        created() {
            GetAllLoopsByProjectId({
                projectId: this.$store.state.projectId,
            }).then(({
                data
            }) => {
                this.loops = data.data.deviceLoops
            }).catch(err => {
                console.log(err)
            })
        },
        mounted() {
            GetDistribution({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.details = data.data.result
                console.log(this.details);
                this.areaId == -1 ? (this.currentId = this.details[0].areaId) : (this.currentId = this.areaId)
                this.currentIndex = this.details.findIndex(item => item.areaId == this.currentId)
                this.getCurrentInfo(this.currentIndex)
            })
        },
        methods: {
            getCurrentInfo(currentIndex) {
                this.details.forEach((item, index) => {
                    if (index == currentIndex) {
                        this.currentName = item.name
                        this.currentUrl = item.url
                    }
                })
            },
            loopDetail(cmd, loopName) {
                this.showLoopDetail = true
                this.currentLoopUrl = loopName
                if (cmd == 'SwitchingClosing') {
                    this.currentLoopTab = '控制'
                } else if (cmd == 'RealTimeData') {
                    this.currentLoopTab = '电力数据'
                }
            },
        }
    };
</script>

<style lang="less" scoped>
    .list {
        width: 100%;
        height: 100%;
        position: absolute;
        left: -4080/192vw;
        top: 0;
        color: #ffffff;
        font-size: 18rem;
        background-image: url("../../assets/img/安防列表.png");
        background-size: 100% 100%;
        padding-top: 230/108vh;
        padding-left: 240/192vw;
        padding-right: 180/192vw;

        .close {
            position: absolute;
            top: 230/108vh;
            right: 200/192vw;
            width: 190/192vw;
            height: 180/108vh;
            cursor: pointer;
        }

        .active {
            color: #0d94ff;
        }

        .names {
            height: 70%;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            align-items: flex-start;

            span {
                margin-bottom: 230/108vh;
            }
        }

        .type {
            justify-content: flex-start;
            border-bottom: 1px solid rgba(255, 255, 255, 0.75);
            margin-bottom: 16px;

            span {
                margin-right: 330/192vw;
                margin-bottom: 130/108vh;
            }
        }
    }

    .full {
        overflow: hidden !important;
        width: 100vw !important;
        height: 100 - 72 * 100 /1080vh !important;
        position: fixed !important;
        left: 0 !important;
        top: 72 * 100 / 1080vh !important;
        margin: 0 !important;
        padding: 0 !important;
        z-index: 999 !important;
        background: #000 !important;
        opacity: 1 !important;

        .diagram {
            width: 100% !important;
            height: 100% !important;
            /*position: fixed !important;*/
            left: 0 !important;
            top: 0 !important;
        }
    }

    .distribution {
        position: fixed;
        top: 6800/108vh;
        left: 14600/192vw;
    }

    .distributionContent {
        width: 4000/192vw;
        height: 3000/108vh;
        background-color: rgba(3, 13, 24, 0.75);

        margin-left: 1vw;
        /*overflow: hidden;*/

        position: relative;

        .title {
            position: absolute;
            left: 120/192vw;
            top: 160/108vh;
            font-size: 18rem;
            color: #e6f3fd;
            height: 24 / 1080 * 100vh;
            z-index: 999;
            cursor: pointer;

            img {
                margin-right: 110/192vw;
                width: 160/192vw;
                height: 130/108vh;
            }
        }

        .btn {
            .wh(12, 16);
            position: absolute;
            top: @h;
            right: @w;
            z-index: 99999;
            color: #ffffff;
            font-size: 18rem;
            cursor: pointer;

            img {
                .wh(16, 16);
                width: @w;
                height: @h;
                margin-right: 7 / 1920 * 100vw;
            }
        }

        .diagram {
            width: 376 / 1920 * 100vw;
            height: 242 / 1080 * 100vh;
            position: absolute;
            left: 120/192vw;
            top: 460/108vh;
        }
    }


    .names::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .names::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .names::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>